// -------------------------
// 🧩 components/CookieBanner.js
// -------------------------
import React, { useState, useEffect } from "react";
import { Snackbar, Alert, Button } from "@mui/material";
import { Link } from "react-router-dom";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) setOpen(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setOpen(false);
  };

  return (
    <Snackbar open={open} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
      <Alert
        severity="info"
        style={{ background: "black" 
              , color: "white",
            alignItems: "center" }} // Personnalisation de l'alerte
        action={
          <Button color="inherit" size="small" onClick={handleAccept}>
            J'accepte
          </Button>
        }
      >
        Ce site utilise des cookies pour améliorer votre expérience. 
        { " " }<Link to="/mentions-legales" style={{ color: "white", textDecoration: "underline" }}>
          En savoir plus
        </Link>
      </Alert>
    </Snackbar>
  );
}